import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import Select2 from "vue3-select2-component/src/Select2.vue";
import ko from "element-plus/es/locale/lang/ko";
import "element-plus/dist/index.css";
import "@/css/common.css";
import "@/css/el-plus_custom.css";
import "@/css/realgrid_custom.css";
require("../node_modules/realgrid/dist/realgrid-style.css");
declare global {
  interface Window {
    daum: any;
    customAlert: any;
    customConfirm: any;
  }
}
createApp(App).use(store).use(router).use(ElementPlus, { locale: ko }).component("Select2", Select2).mount("#app");
